import {translocoConfig} from '@jsverse/transloco';

export function translocoConfigFactory(prodMode: boolean) {
  const savedLang = localStorage.getItem('transloco-lang') || 'en';
  return translocoConfig({
    availableLangs: [savedLang],
    defaultLang: savedLang,
    reRenderOnLangChange: true,
    prodMode: prodMode,
    fallbackLang: savedLang,
  });
}
